module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_tags_remoteEntry_mjs_5ba1d811__;